export default __webpack_public_path__ + "static/media/atg-test-logo.52c12652.svg";